<template>
    <button
        class="animate-hamburger hamburger"
        :class="{'is-active': internalModel, 'hamburger--squeeze': animate}"
        type="button"
        @click="handleClick"
    >
              <span class="hamburger-box">
                <span class="hamburger-inner" />
              </span>
    </button>
</template>

<script>
    import './AnimateHamburger.scss';

    export const ANIMATE_HAMBURGER = 'ANIMATE_HAMBURGER';

    export default {
        name: "AnimateHamburger",
        props: {
            animate: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                internalModel: false,
            };
        },
        methods: {
            handleClick() {
                this.internalModel = !this.internalModel;
                this.$uiBus.$emit(ANIMATE_HAMBURGER, this.internalModel);
            },
            onAnimateHamburger(value) {
                this.internalModel = value;
            }
        },
        mounted() {
            this.$uiBus.$on(ANIMATE_HAMBURGER, this.onAnimateHamburger);
        },
        beforeDestroy() {
            this.$uiBus.$off(ANIMATE_HAMBURGER, this.onAnimateHamburger);
        },
    };
</script>
